import * as React from "react";
function SvgCheck(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.774 7.726l-6.964 9.847a1 1 0 01-1.455.2L5.382 13.63a1.09 1.09 0 01-.159-1.49.99.99 0 011.43-.166l4.148 3.457 6.335-8.959c.208-.325.57-.504.943-.467.373.037.696.284.841.644.146.36.09.774-.146 1.077z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCheck);
export default ForwardRef;
